export default "__VITE_ASSET__60fc6427__"